import { render, staticRenderFns } from "./SearchButton.vue?vue&type=template&id=095b554e&scoped=true"
import script from "./SearchButton.vue?vue&type=script&lang=js"
export * from "./SearchButton.vue?vue&type=script&lang=js"
import style0 from "./SearchButton.vue?vue&type=style&index=0&id=095b554e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b554e",
  null
  
)

export default component.exports